import { render, staticRenderFns } from "./addcommercial_jsxx.vue?vue&type=template&id=9684065e&scoped=true&"
import script from "./addcommercial_jsxx.vue?vue&type=script&lang=js&"
export * from "./addcommercial_jsxx.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_jsxx.vue?vue&type=style&index=0&id=9684065e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9684065e",
  null
  
)

export default component.exports